import { Button, Form, Input, Space, Typography } from 'antd'
import axios, { isAxiosError } from 'axios'
import { useEffect, useState } from 'react'
import SBPhoneInput from '../../modules/sb-antd-phone-input/SBPhoneInput'
import { registerAdmin } from '../../services/AdminService'
import { formatPhoneNumberToE164FromPhoneInput } from '../../utils/PhoneFormatter'
import {
  capsRule,
  containsNumberRule,
  containsSymbolRule,
  isE164Phone,
  lowercaseRule,
  minLengthRule,
  requiredRule,
} from '../../utils/rules'
import { CSRF_COOKE_URL } from '../../utils/urls'

const { Title, Text } = Typography

const RegisterPage = () => {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const onFinish = (values: any) => {
    setIsLoading(true)
    setError(undefined)

    axios
      .get(CSRF_COOKE_URL)
      .then(() => {
        registerAdmin({
          ...values,
          phone: formatPhoneNumberToE164FromPhoneInput(values.phone),
        })
          .then(() => {
            window.location.href = '/'
          })
          .catch((error) => {
            if (isAxiosError(error)) {
              setError(
                'Error during your registration. If this persists contact support.'
              )
            } else {
              // TODO: Improve error message, see service for possibles error codes
              setError(error.message)
            }
          })
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const email = queryParameters.get('email')
    const token = queryParameters.get('token')
    if (!email || !token) {
      setError('No invitations details found!')
      return
    }

    form.setFieldsValue({ email: email!, token: token! })
  }, [])

  return (
    <Space orientation="vertical" className="w-full">
      <Title className="m-0" level={5}>
        Register
      </Title>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="token" noStyle hidden rules={[requiredRule()]}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="first_name" rules={[requiredRule()]}>
          <Input
            size="large"
            className="authField"
            placeholder={'First name'}
          />
        </Form.Item>
        <Form.Item name="last_name" rules={[requiredRule()]}>
          <Input size="large" className="authField" placeholder={'Last name'} />
        </Form.Item>
        <Form.Item name="phone" rules={[isE164Phone()]}>
          <SBPhoneInput disableParentheses enableSearch size="large" />
        </Form.Item>
        <Form.Item name="email" rules={[requiredRule()]}>
          <Input
            disabled
            size="large"
            className="authField"
            placeholder={'Email'}
            autoComplete="email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            requiredRule(),
            minLengthRule(8),
            lowercaseRule(),
            capsRule(),
            containsNumberRule(),
            containsSymbolRule(),
          ]}
        >
          <Input.Password
            size="large"
            placeholder={'Password'}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            disabled={isLoading}
            loading={isLoading}
          >
            Register
          </Button>
        </Form.Item>
      </Form>
      <Text>{error}</Text>
    </Space>
  )
}

export default RegisterPage
